import React from "react";
import { useHistory } from "react-router-dom";
import { useAppUser } from "../../../../../contexts/user-context/UserContext";
import { DashboardMentoringPages } from "../../Mentoring";
import "./styles.scss";

interface IProps {
  title: string;
  showButton?: boolean;
  showBackButton?: boolean;
  sidebarOnly?: boolean;
  type?: "PUBLIC" | "PRIVATE";
}

const MentorProfileCreateHeader = (props: IProps) => {
  const history = useHistory();
  const appUser = useAppUser();

  return (
    <div>
      <div
        className="page-header-wrapper "
        style={{
          width: `calc(100vw - ${props.sidebarOnly ? "100px" : "400px"})`,
        }}
      >
        <div className="blue-line ">
          <div className="text-left title">
            <span className=" header-text">{props.title}</span>
          </div>
          {appUser.userRole.isAdmin && props.showButton && (
            <div className="text-right button">
              <button
                onClick={() => {
                  history.push(DashboardMentoringPages.CREATE_MENTOR_PROFILE);
                }}
                className="header-btn"
              >
                Create Mentor Profile
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MentorProfileCreateHeader;
